import Products from './Products';

export const productsRoutes = [{path: '/products', name: 'Products', Component: Products}];
